angular.module('salesPath2')
  .controller('shortPathCtrl', ['$scope', 'shortPathHelper', 'vehicleModalHelper', 'vehicleCepHelper', 'vehicleHelper', 'mainDataContainer', 'CONSTANTS', '$state', 'actionHelper', 'personHelper', 'CONFIG', 'vehicleServiceHelper', 'allowedChangesHelper', '$log', 'sp2CommonHelper', 'searchHelper', 'appVariables', 'sp2HeaderHelper', 'coownerHelper', 'dataContainerResource', 'DataContainer', 'ApplicationModel','sp2UiHelper', 'vehicleNonEtxModalHelper', '$filter', 'dictionaryServiceHelper', 'dataContainerHelper',
    function($scope, shortPathHelper, vehicleModalHelper, vehicleCepHelper, vehicleHelper, mainDataContainer, CONSTANTS, $state, actionHelper, personHelper, CONFIG, vehicleServiceHelper, allowedChangesHelper, $log, sp2CommonHelper, searchHelper, appVariables, sp2HeaderHelper, coownerHelper, dataContainerResource, DataContainer, ApplicationModel, sp2UiHelper, vehicleNonEtxModalHelper, $filter, dictionaryServiceHelper, dataContainerHelper) {
      $scope.tplData = {
          ownerData: null, //dane wlasciciela
          coownersData: null, //dane wspolwlasciciela
          vehicleCollapsed: true,
          messages: {
              warning: []
          }
      };
      $scope.tplHeaderData = sp2HeaderHelper.tplData;
      $scope.helperData = shortPathHelper.data;
      $scope.settings = {};

      $scope.init = function() {    
        $scope.initOwners();
        $scope.initProtectionDates();
        $scope.initVehicle();
        $scope.getMessages();
        $scope.initVehicleCategoryDict();
        $scope.fireListeners();
      };     

      $scope.fireListeners = function() {
        $scope.$on('$locationChangeStart', function(event, next) {
          // if going back to search page
          if (next.indexOf('search') !== -1) {
            $scope.clearData();
          }
        });
      };

      $scope.initVehicleCategoryDict = function() {
        if ($scope.helperData.registrationTypes.length === 0) {
          dictionaryServiceHelper.getVehicleCategoryService().findByParams({
            query: {
              classification: 'EUROTAX',
              value: ''
            }
          }).then(function(res) {
            $scope.helperData.registrationTypes = res.data.items;
          }, angular.noop);
        }
      };

      $scope.initProtectionDates = function() {
        $scope.settings = sp2HeaderHelper.currentSettings;
        sp2HeaderHelper.currentSettings.object = CONSTANTS.PRODUCT_TYPE_VEHICLE;
        sp2HeaderHelper.initProtectionDates();
      };
      
      $scope.initOwners = function() {      
        $scope.tplData.ownerData = Object.values(mainDataContainer.persons).find(function(person) {
          return person.metaData.clientId === mainDataContainer.insurerId;
        }).getData(true);
        $scope.tplData.coownersData = Object.values(mainDataContainer.persons).filter(function(person) {
            return person.metaData.clientId !== mainDataContainer.insurerId;
        }).map(function(person) {          
          return person.getData(true);
        });

        $scope.tplData.noDrivingLicence = Object.values(mainDataContainer.persons).find(function(person) {
          return !person.dynamicValues.drivingLicenceIssueDate;
        });
        var messages = mainDataContainer.application.messages;
        $scope.tplData.verifyClientAddress = messages && Object.values(messages).some(function(m) {
          return m.code === 'ShortPath0001';
        });
        
        var apkDetails = dataContainerHelper.getApkDetails();
        if ($scope.tplData.ownerData.firstName === apkDetails.firstName && $scope.tplData.ownerData.lastName === apkDetails.lastName) {
          personHelper.setContactDataFromApk(apkDetails, $scope.tplData.ownerData);
        }
      };

      $scope.initVehicle = function() {   
        // zmiana jezyka odswieza widok i powoduje ponowne odpalenie inita. 
        // dodatkowa zmienna blokujaca to  
        if ($scope.helperData.initiated) {
          return;
        }

        if ($scope.helperData.context === 'nonetx') {
          // pojazd poza etx
          $scope.swithToNonEtx();
        } else if (!$scope.helperData.etxVehicleIdentified) {
          // pojazd z etx niejednoznacznie zidentyfikowany, pokaz okno wyszukiwania pojazdu
          vehicleModalHelper.chooseOtherVehicle();
        }
        $scope.helperData.initiated = true;
      };

      $scope.swithToNonEtx = function() {
        vehicleNonEtxModalHelper.modalData.vehicle = mainDataContainer.vehicles[mainDataContainer.selectedVehicle];
        vehicleNonEtxModalHelper.modalData.clientId = mainDataContainer.selectedVehicle;
        vehicleNonEtxModalHelper.modalData.replaceEtxVehicle = true;
        vehicleNonEtxModalHelper.modalData.dataCleared = true;
        if (vehicleNonEtxModalHelper.modalData.allowedChanges.dynamicValues) {
          vehicleNonEtxModalHelper.modalData.allowedChanges.dynamicValues._hasCoowners.disabled = true;
        } else {
          vehicleNonEtxModalHelper.modalData.allowedChanges.dynamicValues = {
            _hasCoowners: {
              disabled: true
            }
          };
        }
      };

      /**
       * aktualizuje datę ochrony "do"
       * @param  {String} type 'start' lub 'end' - którą datę aktualizujemy
       */
      $scope.updateProtectionDate = function(type) {
        return sp2HeaderHelper.updateProtectionDate(type);
      };
      
      $scope.goToMatrix = function() {
          // save persons data
          personHelper.save($scope.tplData.ownerData, 'shortPath', $scope.tplData.ownerData.metaData.clientId, null, null);
          angular.forEach($scope.tplData.coownersData, function(coowner) {
            if (coowner.deleted) {
              delete mainDataContainer.persons[coowner.metaData.clientId];
            } else {
              personHelper.save(coowner, 'shortPath', coowner.metaData.clientId, null, null);
            }
          });

          // save vehicel data
          if ($scope.helperData.context === 'etx') {
            vehicleHelper.currentlyEditedVehicleData.vehicle.setData(vehicleHelper.currentlyEditedVehicleData.vehicleData);
            vehicleHelper.currentlyEditedVehicleData.vehicle.setAdditionalData(vehicleHelper.currentlyEditedVehicleData.vehicleAdditionalData);            
            if (CONFIG.BEHAVIOR.vehicle.etxValuation) {
              vehicleHelper.currentlyEditedVehicleData.vehicleDynamicValues.vehicleValue = vehicleHelper.currentlyEditedVehicleData.vehicleAdditionalData.vehicleValue;
              vehicleHelper.currentlyEditedVehicleData.vehicleDynamicValues._vehicleValueEtxSelect = vehicleHelper.currentlyEditedVehicleData.etxData.vehicleValue;
            }
            vehicleHelper.currentlyEditedVehicleData.vehicle.set('dynamicValues', vehicleHelper.currentlyEditedVehicleData.vehicleDynamicValues);
            vehicleHelper.applyVehicle(vehicleHelper.currentlyEditedVehicleData.vehicle, false);
          } else {
            actionHelper.runAction('nonEtxVehicleSaved');
          }
          appVariables.isInsurerChosen = true;
          actionHelper.runAction('saveApplication');
          $state.go(appVariables.mainState);
      };

      $scope.goBack = function() {
        $scope.clearData();
        $state.go(CONSTANTS.PAGE_START_TABS_SEARCH);
      };

      $scope.clearData = function() {
        mainDataContainer.application = new ApplicationModel();
        mainDataContainer.vehicles = {};
        mainDataContainer.persons = {};
        mainDataContainer.bonusMalus = {};
        mainDataContainer.insurerId = null;
        mainDataContainer.mainInsuredId = null;
        mainDataContainer.nextObjectId = 1;
        mainDataContainer.nextSubjectId = 1;
        mainDataContainer.selectedRisksRefs = [];
        mainDataContainer.selectedVariants = {};
        mainDataContainer.selectedVariants[CONSTANTS.PRODUCT_TYPE_LOCALIZATION] = {};
        mainDataContainer.selectedVariants[CONSTANTS.PRODUCT_TYPE_VEHICLE] = {};
        mainDataContainer.selectedVariants[CONSTANTS.PRODUCT_TYPE_PERSON_GROUP] = {};
        mainDataContainer.selectedVehicle = CONSTANTS.NO_OBJECT;
        appVariables.isInsurerChosen = false;
        $scope.helperData.initiated = false;

        shortPathHelper.clearData();
        vehicleHelper.clearSearchModalData();
        vehicleCepHelper.clearSearchModalData();
        vehicleHelper.clearEditModalData();
        actionHelper.unregisterHelper('vehicleEtxEditModalCtrl');
        sp2CommonHelper.hideActivePopups();
      };

      $scope.checkDrivingLicence = function (person) {
        return person && person.dynamicValues && !person.dynamicValues.drivingLicenceIssueDate;
      };

      $scope.getClientWithoutDrivingLicense = function () {
        var clientWithoutDrivingLicense = [];
        if ($scope.checkDrivingLicence($scope.tplData.ownerData)) {
          clientWithoutDrivingLicense.push($scope.tplData.ownerData.firstName + ' ' + $scope.tplData.ownerData.lastName);
        }
        angular.forEach($scope.tplData.coownersData, function (coowner) {
          if ($scope.checkDrivingLicence(coowner)) {
            clientWithoutDrivingLicense.push(coowner.firstName + ' ' + coowner.lastName);
          }
        });

        return clientWithoutDrivingLicense.length > 0
          ? clientWithoutDrivingLicense.join(', ')
          : undefined;
      };

      $scope.getMessages = function () {
        var clientWithoutDrivingLicense = $scope.getClientWithoutDrivingLicense();
        if (clientWithoutDrivingLicense) {
          $scope.tplData.messages.warning.push(
            $filter('translate')('sp2.shortPath.fillClientDrivingLicenseDate', {
              componentCode: 'sp2',
              params: {clientsName: clientWithoutDrivingLicense}
            }));
        }

        var appMessages = mainDataContainer.application.messages;
        var verifyClientAddress = appMessages && Object.values(appMessages).some(function (m) {
          return m.code === 'ShortPath0001';
        });
        if (verifyClientAddress) {
          $scope.tplData.messages.warning.push($filter('translate')('sp2.shortPath.verifyClientAddress', {
            componentCode: 'sp2'
          }));
        }
      };
      
      $scope.init();
    }
  ]);